import { useEffect, useState } from "react";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import { getApi, postApi } from "../../services/api/globalApi";
import { normalizeOrderAppearance, orderAppearanceDefaults } from "../../utils/orderAppearance";

const sizes = { titleSize: "سایز عنوان اصلی", sectionTitleSize: "سایز عناوین بخش‌ها", labelSize: "سایز برچسب‌ها", textSize: "سایز متن‌ها", amountSize: "سایز مبلغ‌ها" };
const colors = { titleColor: "رنگ عناوین", textColor: "رنگ متن‌ها", surfaceColor: "رنگ پس‌زمینه بخش‌ها", accentColor: "رنگ دکمه اصلی و مبلغ‌ها", borderColor: "رنگ کادرها" };
const path = "admin/publicFieldsForFrontUis";
export default function OrderAppearanceSettings() {
  const [values, setValues] = useState(() => normalizeOrderAppearance());
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const load = async () => {
    setLoading(true); setError(""); setLoadError(false);
    try {
      const response = await getApi({ path });
      setValues(normalizeOrderAppearance(response?.data?.result?.data?.[0]?.orderAppearance));
    } catch { setLoadError(true); setError("دریافت تنظیمات انجام نشد. دوباره تلاش کنید."); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  const change = (page, key, value) => {
    setSaved(false);
    setValues(current => ({ ...current, [page]: { ...current[page], [key]: value } }));
  };
  const save = async event => {
    event.preventDefault(); setSaving(true); setError(""); setSaved(false);
    const normalized = normalizeOrderAppearance(values);
    try {
      await postApi({ path, body: { orderAppearance: normalized } });
      setValues(normalized); setSaved(true);
    } catch { setError("ذخیره تنظیمات انجام نشد. دوباره تلاش کنید."); }
    finally { setSaving(false); }
  };
  return <AdminFormLayout title="صفحه ثبت نهایی سفارش و فاکتور" description="اندازه‌ها بر حسب پیکسل هستند (۱۲ تا ۴۸). فیلد خالی با مقدار پیش‌فرض ذخیره می‌شود. تنظیمات فاکتور در رسید پرداخت و نسخه چاپی نیز اعمال می‌شوند.">
    {loading ? <p role="status">در حال دریافت تنظیمات…</p> : <>
      {error && <p role="alert" className="text-red-700 p-3">{error} <button type="button" onClick={load}>دریافت مجدد</button></p>}
      <form onSubmit={save}>
        <fieldset disabled={saving || loadError}>
          {Object.entries(orderAppearanceDefaults).map(([page, defaults]) => {
            const preview = normalizeOrderAppearance(values)[page];
            return <FormSection key={page} title={page === "checkout" ? "صفحه ثبت نهایی سفارش" : "فاکتور و رسید پرداخت"}>
              <div className="grid gap-5 md:grid-cols-2 p-4">
                {Object.entries(sizes).map(([key, label]) => <label key={key} className="flex flex-col gap-2">{label} (پیکسل)
                  <input className="border rounded-lg p-3" type="number" min="12" max="48" step="1" value={values[page][key]} placeholder={String(defaults[key])} onChange={event => change(page, key, event.target.value)} />
                </label>)}
                {Object.entries(colors).map(([key, label]) => <label key={key} className="flex flex-col gap-2">{label}
                  <div className="flex gap-2"><input aria-label={`انتخاب ${label}`} type="color" value={preview[key]} onChange={event => change(page, key, event.target.value)} /><input className="border rounded-lg p-2 w-full" dir="ltr" pattern="#[0-9a-fA-F]{6}" placeholder={defaults[key]} value={values[page][key]} onChange={event => change(page, key, event.target.value)} /></div>
                </label>)}
                <label className="flex gap-2 items-center"><input type="checkbox" checked={values[page].showTopText} onChange={event => change(page, "showTopText", event.target.checked)} />نمایش متن بالای صفحه</label>
                <label className="flex flex-col gap-2 md:col-span-2">متن بالای صفحه<textarea className="border rounded-lg p-3" maxLength={1000} rows={3} value={values[page].topText} placeholder={defaults.topText} onChange={event => change(page, "topText", event.target.value)} /></label>
              </div>
              <div className="m-4 rounded-xl border p-5 break-words" style={{ backgroundColor: preview.surfaceColor, borderColor: preview.borderColor, color: preview.textColor }}>
                <p className="text-sm mb-3">پیش‌نمایش</p>
                <h2 style={{ fontSize: preview.titleSize, color: preview.titleColor }}> {page === "checkout" ? "تکمیل سفارش" : "فاکتور سفارش"}</h2>
                {preview.showTopText && <p className="whitespace-pre-wrap" style={{ fontSize: preview.textSize }}>{preview.topText}</p>}
                <h3 style={{ fontSize: preview.sectionTitleSize, color: preview.titleColor }}>خلاصه سفارش</h3>
                <p style={{ fontSize: preview.labelSize }}>مبلغ قابل پرداخت</p>
                <p style={{ fontSize: preview.amountSize, color: preview.accentColor }}>۱٬۲۵۰٬۰۰۰ تومان</p>
              </div>
              <button type="button" className="m-4 border rounded-lg p-3" onClick={() => { setValues(current => ({ ...current, [page]: { ...defaults } })); setSaved(false); }}>بازگشت این صفحه به پیش‌فرض</button>
            </FormSection>;
          })}
          <button type="submit" className="rounded-lg bg-indigo-700 text-white px-6 py-3 m-4">{saving ? "در حال ذخیره…" : "ذخیره تنظیمات"}</button>
        </fieldset>
        {saved && <p role="status" className="text-green-700 p-3">تنظیمات با موفقیت ذخیره شد.</p>}
      </form>
    </>}
  </AdminFormLayout>;
}
